import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "upsells" }
const _hoisted_2 = { class: "upsells-categories" }
const _hoisted_3 = { class: "upsells-products-grid" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.settings?.collection_groups, (collection) => {
        return (_openBlock(), _createBlock($setup["CategoryLabel"], {
          key: collection.slug,
          "is-active": $setup.selectedCategory === collection.label,
          label: collection.label,
          onSelected: () => $setup.selectCategory(collection.label, collection.products)
        }, null, 8 /* PROPS */, ["is-active", "label", "onSelected"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.products, (product) => {
        return (_openBlock(), _createBlock($setup["ProductCard"], {
          class: "product-config-upsell-card",
          "allow-multiple": true,
          key: product.id,
          "input-name": 'upsells',
          product: product,
          "is-active": $setup.isProductSelected(product),
          onSelected: () => $setup.toggleProduct(product)
        }, null, 8 /* PROPS */, ["product", "is-active", "onSelected"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}